export const environment = {
  production: true,
  firebase:{
    apiKey: "AIzaSyA46YAZ0okPdAY6tT9MAmWqME9as0WIp80",
    authDomain: "swiggy-clone-3abed.firebaseapp.com",
    databaseURL: "https://swiggy-clone-3abed.firebaseio.com",
    projectId: "swiggy-clone-3abed",
    storageBucket: "swiggy-clone-3abed.appspot.com",
    messagingSenderId: "233436364797",
    appId: "1:233436364797:web:c8f45bf085e4683ae02394",
    measurementId: "G-1EXDFDJFFG"
  }
};
